import { createContext } from 'react'
import { MiwiAppServiceProvider } from '@oneaudi/miwi-feature-service'

const MiwiFeatureServiceContext = createContext<MiwiAppServiceProvider>(null)

export default MiwiFeatureServiceContext
